import {Component, OnInit} from '@angular/core';
import {TokenService} from '../../../../core/auth';

@Component({
  selector: 'app-service-details',
  templateUrl: 'service-details.component.html'
})

export class ServiceDetailsComponent implements OnInit {
  user = this.token.whoAmI();

  constructor(
    private token: TokenService
  ) {
  }

  ngOnInit() {
  }
}
